import { Modal } from 'antd';
import { BaseButton } from '../UI/BaseButton';

// The two bulk deletes the Inbox offers: "Delete completed" on the Actions tab and
// "Delete read" on the Updates tab. Both are irreversible, so both are confirmed. (#2820)
export type DeleteNotificationsMode = 'deleteAllCompleted' | 'deleteAllRead';

interface DeleteNotificationsModalProps {
  open: boolean;
  mode: DeleteNotificationsMode;
  onConfirm: () => void;
  onCancel: () => void;
  confirmLoading?: boolean;
}

const TITLES: Record<DeleteNotificationsMode, string> = {
  deleteAllCompleted: 'You are about to delete all Completed Actions Notifications',
  deleteAllRead: 'You are about to delete all Read Updates Notifications',
};

const DESCRIPTION =
  'When you delete notifications, those will be permanently removed for you. Are you sure you want to delete them?';

export const DeleteNotificationsModal = ({
  open,
  mode,
  onConfirm,
  onCancel,
  confirmLoading = false,
}: DeleteNotificationsModalProps) => (
  <Modal
    title={<div className="text-brand-grey-dark text-base font-semibold">{TITLES[mode]}</div>}
    open={open}
    onCancel={onCancel}
    onClose={onCancel}
    footer={null}
    width={640}
    centered
  >
    <div className="flex flex-col gap-6">
      <p className="text-neutral-900 text-sm font-normal leading-tight">{DESCRIPTION}</p>

      <div className="flex justify-end gap-2">
        <BaseButton size="medium" type="secondary" onClick={onCancel}>
          Cancel
        </BaseButton>

        <BaseButton size="medium" type="primary" danger onClick={onConfirm} disabled={confirmLoading}>
          Delete Notifications
        </BaseButton>
      </div>
    </div>
  </Modal>
);
